function RenderTableData(data, clickEvent){

    const result = Array.isArray(data)
    let columns = []

    if(result){

        delete data[0]['attributes']   
        delete data[0]['key']  

        let datasource = []
        
        columns = Object.entries(data[0]).map((item) => ({
            title: item[0].replaceAll('_', ' '),
            dataIndex: item[0],
            key: item[0]
        }))

        Object.entries(data).map((item, key) => {
            if(typeof item[1]['attributes'] !== 'undefined'){
                delete item[1]['attributes']
            }
            
            item[1]['key'] = key+1
            datasource[key] = item[1]
            return item;
        })

        return { 'datasource': datasource, 'column': columns }
    }else{

        let datasource = {}

        columns = Object.entries(data).map((item, key) => ({
            title: item[0].replaceAll('_', ' '),
            dataIndex: item[0],
            key: item[0]
        }))

        Object.entries(data).map((item, key) => {
            let col = item[0]
            datasource[col] = item[1]
            return item;
        })

        datasource['key'] = 1

        return { 'datasource': [datasource], 'column': columns }
    }  
}

function RenderTableData2(data, clickEvent){
    const dataSource = [
        {
          key: '1',
          name: 'Mike',
          age: 32,
          address: '10 Downing Street',
        },
        {
          key: '2',
          name: 'John',
          age: 42,
          address: '10 Downing Street',
        },
      ];
      
      const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Age',
          dataIndex: 'age',
          key: 'age',
        },
        {
          title: 'Address',
          dataIndex: 'address',
          key: 'address',
        },
      ];

      return { 'datasource': dataSource, 'column': columns }
      //return { 'datasource': dataSource, 'column': columns }
}

function RenderListData(data){
    let response = []

    response = Object.entries(data).map((item, key) => ({
        title : item[0],
        value : item[1]
    }))

    return response
    
}

function emailVerification (email) {
  //var listOfAllowed = ["jubileelife.com", "banca.jubileelife.com"]

  
  /*var domain = email.substring(email.lastIndexOf("@") +1)
  if(listOfAllowed.indexOf(domain) > -1){
      return false
  }else{
      return true
  }*/
  var emailDomain = email.substr(email.length - 15)
  if(emailDomain == 'jubileelife.com'){
    return true
  }else{
    return false
  }
  

}

const doUtility = { RenderTableData, RenderListData, RenderTableData2, emailVerification }

export default doUtility